export const UI_LIMITS = {
  MAX_VISIBLE_SELECTED_ITEMS: 4,
} as const;